module.exports = __webpack_public_path__ + "img/logoFunEats.d2fe036f.png";